export const comment = (nickname = "", comment = "", likes = 0, dislikes = 0, date=Date()) => {
    return ({
        "nickname": nickname,
        "comment": comment,
        "likes": likes,
        "dislikes": dislikes,
        "date":date
    });
}